// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-report-admin {
  width: min(96vw, 860px);
  max-height: 84vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.users-report-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.users-report-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.users-report-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.users-report-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.users-report-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.users-report-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.users-report-admin__body::-webkit-scrollbar {
  width: 8px;
}

.users-report-admin__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
}

.users-report-admin__hint {
  margin: 0 0 0.9rem;
  font-size: 0.85rem;
  color: #9fb4cc;
}

.users-report-admin__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.8rem;
}

.users-report-admin__count {
  font-size: 0.85rem;
  color: #9fb4cc;
}

.users-report-admin__error {
  color: #ff9d9d;
  background: rgba(255, 80, 80, 0.1);
  border: 1px solid rgba(255, 80, 80, 0.3);
  border-radius: 6px;
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.8rem;
  font-size: 0.85rem;
}

.users-report-admin__status {
  color: #9fb4cc;
  font-size: 0.9rem;
  padding: 0.8rem 0;
}

.users-report-admin__table-wrap {
  overflow-x: auto;
}

.users-report-admin__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.users-report-admin__table th,
.users-report-admin__table td {
  text-align: left;
  padding: 0.5rem 0.6rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.15);
  vertical-align: top;
}

.users-report-admin__table th {
  color: #9fb4cc;
  font-weight: 600;
  white-space: nowrap;
}

.users-report-admin__num {
  text-align: right;
}

.users-report-admin__user {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.users-report-admin__name {
  color: #fff;
}

.users-report-admin__email {
  color: #7d90a8;
  font-size: 0.78rem;
}

.users-report-admin__flag {
  display: inline-block;
  padding: 0.1rem 0.45rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}

.users-report-admin__flag--on {
  color: #b7f5c8;
  background: rgba(60, 200, 120, 0.15);
}

.users-report-admin__flag--off {
  color: #c2cede;
  background: rgba(255, 255, 255, 0.06);
}

.users-report-admin__sub {
  display: inline-block;
  margin-left: 0.4rem;
  color: #7d90a8;
  font-size: 0.72rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/users-report-admin-panel/users-report-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,mCAAmC,aAAa,EAAE,cAAc,EAAE;;AAElE;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".users-report-admin {\r\n  width: min(96vw, 860px);\r\n  max-height: 84vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.users-report-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.users-report-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.users-report-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.users-report-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.users-report-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.users-report-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.users-report-admin__body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.users-report-admin__body::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.25);\r\n  border-radius: 4px;\r\n}\r\n\r\n.users-report-admin__hint {\r\n  margin: 0 0 0.9rem;\r\n  font-size: 0.85rem;\r\n  color: #9fb4cc;\r\n}\r\n\r\n.users-report-admin__toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n.users-report-admin__count {\r\n  font-size: 0.85rem;\r\n  color: #9fb4cc;\r\n}\r\n\r\n.users-report-admin__error {\r\n  color: #ff9d9d;\r\n  background: rgba(255, 80, 80, 0.1);\r\n  border: 1px solid rgba(255, 80, 80, 0.3);\r\n  border-radius: 6px;\r\n  padding: 0.6rem 0.8rem;\r\n  margin-bottom: 0.8rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.users-report-admin__status {\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n  padding: 0.8rem 0;\r\n}\r\n\r\n.users-report-admin__table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.users-report-admin__table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.users-report-admin__table th,\r\n.users-report-admin__table td {\r\n  text-align: left;\r\n  padding: 0.5rem 0.6rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.15);\r\n  vertical-align: top;\r\n}\r\n\r\n.users-report-admin__table th {\r\n  color: #9fb4cc;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.users-report-admin__num {\r\n  text-align: right;\r\n}\r\n\r\n.users-report-admin__user {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.users-report-admin__name {\r\n  color: #fff;\r\n}\r\n\r\n.users-report-admin__email {\r\n  color: #7d90a8;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.users-report-admin__flag {\r\n  display: inline-block;\r\n  padding: 0.1rem 0.45rem;\r\n  border-radius: 4px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.users-report-admin__flag--on {\r\n  color: #b7f5c8;\r\n  background: rgba(60, 200, 120, 0.15);\r\n}\r\n\r\n.users-report-admin__flag--off {\r\n  color: #c2cede;\r\n  background: rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.users-report-admin__sub {\r\n  display: inline-block;\r\n  margin-left: 0.4rem;\r\n  color: #7d90a8;\r\n  font-size: 0.72rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
